import { render, staticRenderFns } from "./CComments.vue?vue&type=template&id=4b2993f7"
import script from "./CComments.vue?vue&type=script&lang=js"
export * from "./CComments.vue?vue&type=script&lang=js"
import style0 from "./CComments.vue?vue&type=style&index=0&id=4b2993f7&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b2993f7')) {
      api.createRecord('4b2993f7', component.options)
    } else {
      api.reload('4b2993f7', component.options)
    }
    module.hot.accept("./CComments.vue?vue&type=template&id=4b2993f7", function () {
      api.rerender('4b2993f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CComments.vue"
export default component.exports